import Model, { attr } from '@ember-data/model';

export default class ChannelUserModel extends Model {
  @attr('string') guestProfileLink!: string;
  @attr('string') guestProfilePicture!: string;
  @attr('boolean') verified!: boolean;
  @attr('number') reviews!: number;
  @attr('number') rating!: number;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'channel-user': ChannelUserModel;
  }
}
